import React from "react";
import { map } from "lodash";
import { connect } from "react-redux";

import FontIcon from "react-md/lib/FontIcons";

import { setDialog } from "../../actions/dialogActions";

const Table = ({ history, rights, setDialog }) => {
  return (
    <div className="table">
      <div className="table-row header">
        <div className="table-col">Název</div>
        <div className="table-col">Práva</div>
        <div className="table-col actions">Akce</div>
      </div>
      {map(rights, (item, i) => (
        <div
          className="table-row"
          key={i}
          onClick={() => setDialog("AdminResourceEditRights", { right: item })}
        >
          <div className="table-col">{item.user.name}</div>
          <div className="table-col">{item.rights}</div>
          <div className="table-col actions">
            <FontIcon
              className="icon"
              onClick={e => {
                e.stopPropagation();
                setDialog("AdminResourceDeleteRights", {
                  resourceId: item.resource.id,
                  rightId: item.id
                });
              }}
            >
              delete
            </FontIcon>
          </div>
        </div>
      ))}
    </div>
  );
};

export default connect(null, { setDialog })(Table);



// WEBPACK FOOTER //
// ./src/components/resource/Table.js